export default "__VITE_ASSET__tHvuDW8$__"